import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    },
    syncLogsGrid: {
        margin: theme.spacing(1),
    },
    addNewFolderButton: {
        marginBottom: 10,
    },
    deleteButton: {
        minWidth: 24,
        maxWidth: 30,
        padding: '4px 5px',
    },
    deleteButtonIcon: {
        fontSize: 16,
        '&:hover': {
            cursor: 'pointer',
        },
    },
    dialog: {
        '& .k-dialog': {
            '& .k-dialog-content': {
                marginTop: theme.spacing(2),
            },

            '& .k-dialog-titlebar': {
                backgroundColor: '#8DD9C8',
                fontSize: '1em',
            },
            '& .k-form-buttons': {
                justifyContent: 'flex-end',
            },
            '& .k-window-title': {
                fontSize: '1.4em',
                backgroundColor: '#8DD9C8',
                color: 'rgb(255, 255, 255)',
            },
            '& .k-step-label': {
                '& .k-step-text': {
                    display: 'block',
                    whiteSpace: 'normal',
                },
            },
        },
    },
    confirmationDialog: {
        display: 'flex',
        justifyContent: 'center',
    },

    buttonGridAction: {
        display: 'inline-block',
        margin: 'auto 5px',
    },
    normalizeColumn: {
        fontSize: '12px',
        '& td:first-child': {
            fontWeight: 'normal !important',
        },
    }
}));

export default useStyles;
